var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pagination-text"},[_vm._v(" "+_vm._s(_vm.from)+" - "+_vm._s(_vm.to)+" "+_vm._s(_vm.$t('pagination.of'))+" "+_vm._s(_vm.total)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }